export class Menu {
	public id: string;
	public label: string;
	public url: string;
	public type: string;
	public target: string;
	public icon: string;
	public role: any;
	public isHasCurId?: boolean;
}

export class MenuType {
	public name: string;
	public menuList: Menu[];
}

export class MenuStatus {
	status: boolean;
}

export const MENUS: MenuType[] = [
	// Top menu list
	{
		name: 'top',
		menuList: [
			{
				id: 'news-event',
				label: 'News & Events',
				url: 'https://www.aisvietnam.com/community/news-events/',
				type: 'link',
				target: '',
				icon: '',
				role: []
			},
			{
				id: 'photo-gallery',
				label: 'Photo Gallery',
				url: 'https://www.aisvietnam.com/about-us/our-campuses/',
				type: 'link',
				target: '',
				icon: '',
				role: []
			},
			{
				id: 'login-mail',
				label: 'Login Mail',
				url: 'https://portal.office.com',
				type: 'link',
				target: '_blank',
				icon: '',
				role: []
			},
			{
				id: 'my-ais',
				label: 'myAIS',
				url: 'http://www.myais.vn',
				type: 'link',
				target: '_blank',
				icon: '',
				role: []
			},
			{
				id: 'sitemap',
				label: 'Sitemap',
				url: 'https://www.aisvietnam.com/contact/',
				type: 'link',
				target: '',
				icon: '',
				role: []
			}
		]
	},
	// Social connect top menu list
	{
		name: 'social-top',
		menuList: [
			{
				id: 'facebook',
				label: 'Facebook',
				url: 'https://www.facebook.com/AustralianInternationalSchoolVietnam/',
				type: 'link',
				target: '_blank',
				icon: '',
				role: []
			},
			{
				id: 'twitter',
				label: 'Twitter',
				url: 'https://twitter.com/#!/aisvietnam',
				type: 'link',
				target: '_blank',
				icon: '',
				role: []
			},
			{
				id: 'google',
				label: 'Google',
				url:
					'https://plus.google.com/u/0/+AustralianInternationalSchoolVietnamTT/posts',
				type: 'link',
				target: '_blank',
				icon: '',
				role: []
			},
			{
				id: 'youtube',
				label: 'Youtube',
				url: 'https://www.youtube.com/user/aisvietnam',
				type: 'link',
				target: '_blank',
				icon: '',
				role: []
			},
			{
				id: 'envelope-o',
				label: 'Email',
				url: 'http://portal.office.com/',
				type: 'link',
				target: '_blank',
				icon: '',
				role: []
			}
		]
	},
	// Login main menu
	{
		name: 'login-main',
		menuList: [
			{
				id: 'register',
				label: 'Register',
				url: '/hol-register',
				type: 'route',
				target: '',
				icon: '',
				role: []
			},
			{
				id: 'login',
				label: 'Login',
				url: '/hol-login',
				type: 'route',
				target: '',
				icon: '',
				role: []
			}
		]
	},
	// Login main menu
	{
		name: 'hol-login',
		menuList: [
			{
				id: 'register',
				label: 'Register',
				url: '/hol-register',
				type: 'route',
				target: '',
				icon: '',
				role: []
			},
			{
				id: 'login',
				label: 'Login',
				url: '/hol-login',
				type: 'route',
				target: '',
				icon: '',
				role: []
			}
		]
	},
	// Camp module main menu list
	{
		name: 'camp-main',
		menuList: []
	},
	// ASA module main menu list
	{
		name: 'asa-main',
		menuList: []
	},
	// ASA module sub menu list
	{
		name: 'asa-sub',
		menuList: [
			{
				id: 'bookingClasses',
				label: 'Booking Classes',
				url: '/booking/students',
				type: 'route',
				target: '',
				icon: '',
				role: []
			},
			// {
			//     "id": "manageBooking",
			//     "label": "Manage Booking",
			//     "url":	"",
			//     "type":	"route",
			//     "target": "",
			//     "icon": "",
			//     "role": []
			// },
			{
				id: 'attendance',
				label: 'Attendance',
				url: '/parent/attendance',
				type: 'route',
				target: '',
				icon: '',
				role: []
			},
			{
				id: 'schedule',
				label: 'Schedule',
				url: '/schedule/list',
				type: 'route',
				target: '',
				icon: '',
				role: []
			}
		]
	},
	// Camp module admin sidebar list
	{
		name: 'camp-admin-sidebar',
		menuList: [
			{
				id: 'camp-program',
				label: 'Camp Programmes',
				url: '/camps/list',
				type: 'route',
				target: '',
				icon: 'nature_people',
				role: []
			},
			{
				id: 'student',
				label: 'Students',
				url: '/students/list',
				type: 'route',
				target: '',
				icon: 'people',
				role: []
			},
			{
				id: 'camp-report',
				label: 'Camp Reports',
				url: '/camps/report',
				type: 'route',
				target: '',
				icon: 'rate_review',
				role: []
			}
		]
	},
	// Asa module admin sidebar list
	{
		name: 'asa-admin-sidebar',
		menuList: [
			{
				id: 'classes',
				label: 'Classes',
				url: '/classes/list',
				type: 'route',
				target: '',
				icon: 'store',
				role: []
			},
			{
				id: 'student',
				label: 'Students',
				url: '/students/list',
				type: 'route',
				target: '',
				icon: 'people',
				role: []
			},
			{
				id: 'booking',
				label: 'Bookings',
				url: '/booking/list',
				type: 'route',
				target: '',
				icon: 'bookmark',
				role: []
			},
			{
				id: 'email',
				label: 'Email',
				url: '/email/list',
				type: 'route',
				target: '',
				icon: 'mail',
				role: []
			},
			{
				id: 'attendances',
				label: 'Attendances',
				url: '/attendances',
				type: 'route',
				target: '',
				icon: 'spellcheck',
				role: []
			},
			{
				id: 'settings',
				label: 'Settings',
				url: '/settings',
				type: 'route',
				target: '',
				icon: 'settings',
				role: []
			}
		]
	},
	// Bus module parent sidebar list
	{
		name: 'bus-parent-sidebar',
		menuList: [
			{
				id: 'bus-attendance',
				label: 'Bus attendance',
				url: '',
				type: 'route',
				target: '',
				icon: 'store',
				role: []
			},
			{
				id: 'bus-profile',
				label: 'Profile',
				url: '',
				type: 'route',
				target: '',
				icon: 'people',
				role: []
			}
		]
	},
	// Bus module parent sidebar list
	{
		name: 'bus-admin-sidebar',
		menuList: [
			{
				id: 'bus-schedule',
				label: 'Daily transport list',
				url: 'bus-schedules',
				type: 'route',
				target: '',
				icon: 'directions_bus',
				role: ['system', 'manager']
			},
			{
				id: 'bus-student-management',
				label: 'Student report',
				url: 'students/list',
				type: 'route',
				target: '',
				icon: 'assignment_ind',
				role: ['system']
			},
			{
				id: 'bus-report',
				label: 'Bus report',
				url: 'report',
				type: 'route',
				target: '',
				icon: 'assessment',
				role: ['system']
			},
			{
				id: 'bus-settings',
				label: 'Settings',
				url: 'settings',
				type: 'route',
				target: '',
				icon: 'settings',
				role: ['system']
			}
		]
	},
	// Holiday module main menu list
	{
		name: 'holiday-main',
		menuList: []
	},
	// holiday module admin sidebar list
	{
		name: 'holiday-admin-sidebar',
		menuList: [
			{
				id: 'booking',
				label: 'Bookings',
				url: '/booking/list',
				type: 'route',
				target: '',
				icon: 'bookmark',
				role: ['system']
			},
			{
				id: 'courses',
				label: 'Courses',
				url: '/courses/list',
				type: 'route',
				target: '',
				icon: 'book',
				role: ['system']
			},
			{
				id: 'classes',
				label: 'Classes',
				url: '/classes/list',
				type: 'route',
				target: '',
				icon: 'store',
				role: ['system', 'manager']
			},
			{
				id: 'student',
				label: 'Students',
				url: '/students/list',
				type: 'route',
				target: '',
				icon: 'people',
				role: ['system']
			},
			{
				id: 'email',
				label: 'Email',
				url: '/email/list',
				type: 'route',
				target: '',
				icon: 'mail',
				role: ['system', 'manager']
			},
			{
				id: 'attendances',
				label: 'Attendances',
				url: '/attendances',
				type: 'route',
				target: '',
				icon: 'spellcheck',
				role: ['system', 'manager']
			},
			{
				id: 'parents',
				label: 'Parents',
				url: '/parents',
				type: 'route',
				target: '',
				icon: 'people',
				role: ['system']
			},
			{
				id: 'setting',
				label: 'Setting',
				url: '/setting',
				type: 'route',
				target: '',
				icon: 'widgets',
				role: ['system']
			}
		]
	},
	{
		name: 'holiday-staff-sidebar',
		menuList: [
			{
				id: 'attendances',
				label: 'Attendances',
				url: '/attendances',
				type: 'route',
				target: '',
				icon: 'spellcheck',
				role: []
			}
		]
	},
	// Holiday parent sub menu
	{
		name: 'holiday-sub',
		menuList: [
			{
				id: 'holidayBooking',
				label: 'Booking',
				url: '/booking/students',
				type: 'route',
				target: '',
				icon: '',
				role: []
			},
			{
				id: 'holidayAttendance',
				label: 'Attendance',
				url: '/view-attendance',
				type: 'route',
				target: '',
				icon: '',
				role: []
			}
		]
	},

	// re-enrollment module admin sidebar list
	{
		name: 'reen-admin-sidebar',
		menuList: [
			{
				id: 'response',
				label: 'Responses',
				url: '/response/list',
				type: 'route',
				target: '',
				icon: 'bookmark',
				role: ['system']
			},
			{
				id: 'email',
				label: 'Email',
				url: '/email/list',
				type: 'route',
				target: '',
				icon: 'email',
				role: ['system']
			},
			{
				id: 'student',
				label: 'Students',
				url: '/reen-student',
				type: 'route',
				target: '',
				icon: 'store',
				role: ['system']
			},
			{
				id: 'report',
				label: 'Report',
				url: '/report',
				type: 'route',
				target: '',
				icon: 'assessment',
				role: ['system']
			}
		]
	},

	// conference booking system module admin sidebar list
	// role example : 'system', 'manager', 'parent'
	{
		name: 'conference-admin-sidebar',
		menuList: [
			{
				id: 'interviews',
				label: 'Booking rounds',
				url: '/interviews',
				type: 'route',
				target: '',
				icon: 'dashboard',
				role: ['system'],
			},
			{
				id: 'setting',
				label: 'Settings',
				url: '/setting',
				type: 'route',
				target: '',
				icon: 'build',
				role: ['system']
			},
			{
				id: 'master-data',
				label: 'Master Data',
				url: '/master-data',
				type: 'route',
				target: '',
				icon: 'storage',
				role: ['system']
			},
			{
				id: 'manage-time-slots',
				label: 'Manage Time Slots',
				url: '/manage-time-slots',
				type: 'route',
				target: '',
				icon: 'timeline',
				role: ['system', 'teacher']
			},
			{
				id: 'booking-interview-master',
				label: 'Parent Booking',
				url: '/manage-interview',
				type: 'route',
				target: '',
				icon: 'date_range',
				role: ['system']
			},
			{
				id: 'booking-interview-teacher',
				label: 'Manage Interview',
				url: '/manage-interview/my-interview',
				type: 'route',
				target: '',
				icon: 'date_range',
				role: ['teacher']
			},
			{
				id: 'user-management',
				label: 'User Management',
				url: '/user-management',
				type: 'route',
				target: '',
				icon: 'group',
				role: ['system']
			},
			{
				id: 'report',
				label: 'Report',
				url: '/report',
				type: 'route',
				target: '',
				icon: 'insert_chart',
				role: ['system']
			}
		]
	}
	
];



// WEBPACK FOOTER //
// ./src/common/modules/core/models/Menu.ts